import { DiagnosticsImagingSection } from "@/features/patient/diagnostics/components/DiagnosticsImagingView";
import { useDiagnosticsImaging } from "@/features/patient/diagnostics/utils/adaptDiagnostics";

export function DiagnosticsPage() {
  const { labResults, isLoading } = useDiagnosticsImaging();
  return (
    <DiagnosticsImagingSection
      labResults={labResults}
      isLoading={isLoading}
    />
  );
}
